import React,{useEffect, useState} from "react"
import { useNavigate } from "react-router-dom"

import { Row, Col, Card, CardBody, CardTitle, InputGroup, Label, FormGroup, Button, Modal, Pagination, PaginationItem, PaginationLink } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import { connect } from "react-redux";
import * as url from "../../helpers/url_helper"
import { setBreadcrumbItems } from "../../store/actions";
import moment from "moment"
import { RingLoader } from "react-spinners";
import { BarLoader } from "react-spinners";

const Planning = (props) => {
  document.title = "Planning | Interface de plannification des agents";
  const navigate = useNavigate();

  const breadcrumbItems = [
    { title: "ueDigital", link: "/dashboard" },
    { title: "Rapports", link: "#" },
    { title: "Planning des agens", link: "#" },
  ]
  const [loadingPlanning, setLoadingPlanning] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [currPage, setCurrPage] = useState(0);
  const [agences, setAgences] = useState([]);
  const [dest, setDest] = useState('');
  const [selectedDest, setSelectedDest] = useState(null);
  const [operations, setOperations] = useState([]);
  const [lockMessage, setLockMessage] = useState(null);
  const [plannings, setPlannings] = useState([]);
  const [totalPlannings, setTotalPlannings] = useState(0);
  const [car, setCar] = useState("");
  const [bordSend, setBordSend] = useState("");
  const [agTransit, setAgTransit] = useState(null);
  const [heure, setHeure] = useState(moment().format("YYYY-MM-DD HH:mm"));
  const [selectedAgTransit, setSelectedAgTransit] = useState(null);
  const handleAgTransit= (event)=>{ setSelectedAgTransit(event); setAgTransit(event.value); }
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const optionGroup = [ { options: agences } ]
  const [modal_opera, setmodal_opera] = useState(false)
  const [modal_lock, setmodal_lock] = useState(false)
  const [modal_send, setmodal_send] = useState(false)
  let [loading, setLoading] = useState(false);
  let [lockLoading, setLockLoading] = useState(false);
  const [msgError, setMsgError]= useState("");
  const [msgSuccess, setMsgSuccess]= useState("");
  const handleStartDate= (date)=>{ setStartDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleEndDate= (date)=>{ setEndDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleSendDate= (date)=>{ setHeure(moment(date[0]).format("DD-MM-YYYY HH:mm")); }
  const handleDestination= (event)=>{ setSelectedDest(event); setDest(event.value); }
  const userJson= JSON.parse(localStorage.getItem("user"));

  const loadAgences= ()=> {
    let userJson= JSON.parse(localStorage.getItem("user"));
    let agencesArray= [{label: "Aucun transit", value: null}];
    fetch(`${url.BACKEND_URL}/user?agence=${userJson.usAgence.agId}&size=100`, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        agencesArray=[
          ...agencesArray,
          ...responseJson.data.map(item=>({
          label: item.agNom,
          value: item.agId
        }))];
        setAgences(agencesArray);
    } else {  }
    }) .catch((error) => {  });
  };
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  function tog_get_opera() {
    setmodal_opera(!modal_opera)
    removeBodyCss()
  }
  function tog_lock_bord() {
    setmodal_lock(!modal_lock)
    removeBodyCss()
  }
  function tog_send_bord() {
    setmodal_send(!modal_send)
    removeBodyCss()
  }
  const loadPlanning=(page)=> {
    setLoadingPlanning(true)
    fetch(`${url.BACKEND_URL}/repartitions?start=${startDate}&end=${endDate}&page=${page}&size=30&entreprise=${userJson.usAgence.agEtp.etpId}`, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { console.log(responseJson.data);
      if (responseJson.status==200) { 
        setPlannings(responseJson.data)
        setTotalPlannings(responseJson.totalElement)
        setTotalPage(responseJson.totalPage)
        setCurrPage(responseJson.current_page)
        setLoadingPlanning(false)
    } else {  setLoadingPlanning(false) }
    }) .catch((error) => { setLoadingPlanning(false) });
  };
  
  const loadOperation=(bordId)=> {
    setLoading(true);
    fetch(url.BACKEND_URL+"/operation?bord="+bordId, {
      method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.status==200) { 
        setOperations(responseJson.data)
        setLoading(false);
    } else {  }
    }) .catch((error) => {  });
  };
  
  const lockBord = (bordId) => {
    setLockLoading(true);
    
    fetch(url.BACKEND_URL + "/bordereau/lock/" + bordId, {
      method: 'GET', headers: {'Accept': 'application/json', 'Content-Type': 'application/json'}})
    .then((response) => {
      const statusCode = response.status;
      if (statusCode === 200) {
        return response.json().then((responseJson) => {
          setLockLoading(false);
          if (responseJson.data.bordLock === 1) {
            setLockMessage("Le bordereau a été verrouillé avec succès"); } 
          else { setLockMessage("Le bordereau a été déverrouillé avec succès"); }
          loadPlanning();
        });
      } else {
        return response.json().then((responseJson) => {
          setLockLoading(false); setLockMessage(`Erreur (${statusCode}): ${responseJson.message}`);
        });
      }
    })
    .catch((error) => {
      setLockLoading(false); setLockMessage("Erreur lors de la requête: " + error.message);
    });
  };
  
  const savePlanning=()=>{
      const data= JSON.stringify(
          {
            agence: {agId: userJson?.usAgence?.agId}, 
            coName: userJson?.usNom, 
            date: moment().format("YYYY-MM-DD"),
            heure: moment().format("HH:mm")
          });
          console.log(data);
          
      fetch(`${url.BACKEND_URL}/repartitions`, { method: 'POST', headers: {'Content-Type': 'application/json' },
        body:  data})
      .then((response) => response.json())
      .then((responseJson) => { console.log(responseJson.data);
        if (responseJson.status==200) { 
          loadPlanning();
          //setMsgSuccess(responseJson.message)
           navigate(`/planning/${responseJson.data.id}`);
          setTimeout(() => { tog_send_bord(); }, 500); 
      } else {  }
      }) .catch((error) => {  });
    
  }

  useEffect(() => {
    props.setBreadcrumbItems('Bordereaux', breadcrumbItems)
    loadAgences()
    loadPlanning(0)
  }, [])

  const getOperation=(item)=> {
    return (
        <Row>
          <Col xl="12">
            <div className="table-rep-plugin">
              <div className="table-responsive mb-0" data-pattern="priority-columns">
              <Table id="tech-companies-1" className="table table-striped table-bordered">
              <Tbody>
                      {operations.map((item, key)=>(
                      <Tr>
                        <Th>
                          <strong>{item.opAgdest.agNom}</strong>
                        </Th>
                        <Td>{item.opCode}</Td>
                        <Td>{moment(item.opCreate).format("DD-MM-YY HH:mm:ss")}</Td>
                        <Td>{item.opExp} ({item.opPhonexp})</Td>
                        <Td>{item.opDest} ({item.opDestphone})</Td>
                        <Td>{item.opFrais} FCFA</Td>
                        <Td style={{ fontSize: 9 }}><strong>{item.opStat.etatLibelle}</strong></Td>
                      </Tr>
                      ))}
                    </Tbody>
              </Table>
              </div>
            </div>
          </Col>
        </Row>);
      };

  return (
    <React.Fragment>
      
      <Modal
        size="l"
        isOpen={modal_opera}
        toggle={() => { tog_get_opera() }}
        >
        <div className="modal-header bg-primary text-white">
          <h2 className="modal-title mt-0" id="myLargeModalLabel">Créer le planning du jour pour l'agence {userJson?.usAgence?.agNom}</h2>
          <button
            onClick={() => {
              setmodal_send(false)
            }}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true" style={{ color: "black" }}>x</span>
          </button>
        </div>
        <div className="modal-body">
          <Col xl="12">
            <FormGroup className="mb-4">
              <div className="mb-3">
                <label className="form-label" htmlFor="formrow-firstname-input">Agence</label>
                <input type="text" value={userJson?.usAgence?.agNom} readOnly={true} className="form-control" id="exp" placeholder="Nom de l'agence"/>
              </div>
            </FormGroup>
          </Col>
          <Col xl="12">
            <FormGroup className="mb-4">
              <div className="mb-3">
                <label className="form-label" htmlFor="formrow-firstname-input">Responsable</label>
                <input type="text" value={userJson?.usNom} readOnly={true} className="form-control" id="exp" placeholder="Nom du CO"/>
              </div>
            </FormGroup>
          </Col>
          <Col xl="12">
            <FormGroup className="mb-4">
              <div className="mb-3">
                <label className="form-label" htmlFor="formrow-firstname-input">Date d'édition</label>
                <input type="text" value={moment().format("DD-MM-YYYY")} readOnly={true} className="form-control" id="exp" placeholder="Date édition"/>
              </div>
            </FormGroup>
          </Col>
          <Col xl="12">
            <FormGroup className="mb-4">
              <div className="mb-3">
                <label className="form-label" htmlFor="formrow-firstname-input">Heure d'édition</label>
                <input type="text" value={moment().format("HH:mm")} readOnly={true} className="form-control" id="exp" placeholder="Heure édition"/>
              </div>
            </FormGroup>
          </Col>
          <Col xl="12">
            <Button className="btn btn-lg btn-primary" style={{ width: "100%" }} tag="button" onClick={() => {savePlanning()}}>
              ENREGISTRER
            </Button>
          </Col>
        </div>
        
      </Modal>
      {/* <Row className="mb-4">
        <Col xl="4">
          <Button className="btn btn-lg btn-info" tag="button" data-toggle="modal" data-target=".bs-example-modal-lg" onClick={() => {tog_get_opera()}}>
            CREER LE PLANNING DU JOUR
          </Button>
        </Col>
      </Row> */}
      <Row>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Début</Label>
            <InputGroup>
              
              <Flatpickr
                className="form-control d-block"
                placeholder="Date début"
                value={startDate}
                onChange={handleStartDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Fin</Label>
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="Date Fin"
                value={endDate}
                onChange={handleEndDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        
        <Col lg="3">
          <div className="mt-3">
            <Button type="button" style={{ width: "100%" }} onClick={()=>{loadPlanning(0)}} color="primary" data-toggle="Button" size="lg" className="mt-2 waves-effect waves-light">Rechargé</Button>
          </div>
        </Col>
      </Row>
     <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="h4">{totalPlannings} élément(s) </CardTitle>
              <Card>
                {totalPage ==0 ? ( null): totalPage>=25 ? (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: 25}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadPlanning(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadPlanning(totalPage-1)}>......{totalPage-1}</PaginationLink></PaginationItem>
                      <PaginationItem><PaginationLink onClick={()=>loadPlanning(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>): (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: totalPage}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadPlanning(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadPlanning(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>)}
              </Card>

              <div className="table-rep-plugin">
                <div
                  className="table-responsive mb-0"
                  data-pattern="priority-columns"
                >
                  <div>
                    {loadingPlanning ? (<BarLoader width={"100%"} height={6}/>): null}
                  </div>
                  <Table
                    id="tech-companies-1"
                    className="table table-striped table-bordered"
                  >
                    <Thead>
                      <Tr>
                        <Th>Agence</Th>
                        <Th data-priority="1">Responsable</Th>
                        <Th data-priority="3">Date</Th>
                        <Th data-priority="3">Heure</Th>
                        <Th data-priority="6">Consulter</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {plannings.map((item, key)=>(
                      <Tr>
                        <Th>
                          <strong>{item.agence.agNom}</strong>
                        </Th>
                        <Td>{item.coName}</Td>
                        <Td>{item.date}</Td>
                        <Td>{item.heure}</Td>
                        <Td><Button onClick={()=>{ navigate(`/planning/${item.id}`) }}><i className="fa fa-eye"></i></Button></Td>
                        
                      </Tr>
                      ))}
                      
                    </Tbody>
                  </Table>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

    </React.Fragment>
  )
}
export default connect(null, { setBreadcrumbItems })(Planning);